export const habaCheckout = {
  habaOrderSummary: {
    subTotal: 'Product value',
    shipping: 'Shipping costs',
    shippingSPED: 'Shipping costs incl. freight costs',
    totalDiscounts: 'Discounts',
    promotionSavings: 'Savings from promotions',
    promotionCoupons: 'Promotional benefit',
    totalSavings: 'Total savings:',
    giftCard: 'Gift card',
    giftCards: 'Gift cards',
    giftCardsResidualValue: 'Gift card remaining value',
    total: 'Total amount',
    safeSSL: 'All prices in {{currency}} incl. VAT plus shipping and service costs.',
    help: 'Need help?',
    subHelp1: 'Contact',
    subHelp2: 'our customer service here',
    btn: {
      label_0: 'Continue to payment method',
      label_1: 'Continue to overview',
      label_2: 'Continue to overview',
    },
    portoFlatrate: {
      title: 'Shipping flat rate:',
      text: 'one-time <strong>{{price}}</strong> then {{days}} days free shipping throughout {{country}}.',
      moreInfo: 'Learn',
      more: 'more',
      expirationInfo: 'Shipping flat rate valid until {{expirationDate}}',
      cancel: 'Remove',
    },
    promotionsGiftcardInfo: 'Promotional codes and gift cards can be redeemed in the last step.',
    promotionsInfo: 'Promotional codes can be redeemed in the last step.',
    promotionsInfoTemporary:
      'Unfortunately, you cannot redeem promotional codes at the moment – but we are working hard to make this possible again soon.',
    minAmountForFreeDelivery: 'Orders over {{amount}} qualify for free shipping.',
    backToShopping: 'Continue shopping',
    untilFreeCost: 'until free shipping!',
    priceSimulateFailed:
      'Currently no promotions can be applied. Complete the order without promotions and promotional codes or try again later',
    priceUpdateModal: {
      headline: 'Product updates',
      copy: 'Oh! It looks like some products you added to your cart have had a price update. Please take a look and decide whether you want to keep these products in your order list or remove them by clicking here. Please note this price check does not consider price reductions from current promotions.',
      subHeadline: 'Review your updated products',
      oldPrice: 'Old price',
      newPrice: 'New price',
      removeButton: 'Remove',
      stayButton: 'Keep',
      stayAllButton: 'Keep all in cart',
    },
    helperTitle: 'Promotional codes and gift cards can be redeemed in the last step.',
  },
  habaConfirmation: {
    thankYouHeading: 'Thank you for your order!',
    thankYouText:
      'Confirmation of your order and further information about the right of withdrawal and return will be sent to you by email at the following address',
    total: 'Total amount',
    haveOneSecond: 'Have a few more seconds?',
  },
  habaPayment: {
    paymentMethod: 'Payment method',
    paymentMethodNotSelected: 'Please select a payment method.',
    paymentMethodNotActive: {
      title: 'Please try a different payment method.',
      message:
        '<b>Payment on invoice is unfortunately not possible,</b> because your billing address is outside of Germany, Austria and Switzerland.',
    },
    birthdateModal: {
      title: 'Please verify your identity',
      paragraph:
        'For this payment method we need additional data to verify your identity. After that you can complete your purchase.',
      dataProtection: 'Privacy policy',
      inputPlaceholder: 'Date of birth (DD.MM.YYYY)',
      submitButton: 'Confirm',
      dataProtectionLink: 'Privacy policy',
      dataProtectionText: 'Our privacy policy applies',
    },
    birthdateError: {
      title: 'Payment method unfortunately not permitted.',
      paragraph:
        'Unfortunately, you have not been approved to use this payment method. Please try a different payment method.',
    },
    disabledPaymentMethods: {
      and: 'or',
      isDisabledForGiftCards: '{{restrictedPaymentMethods}} cannot be used with <b>gift cards</b>.',
      isDisabledForPortoFlatrate:
        '{{restrictedPaymentMethods}} cannot be used while <b>shipping flat rate</b> is being purchased.',
      advancePayment:
        'Please note that the payment method "prepayment" cannot be used in conjunction with vouchers.',
    },
    submitButton: 'Close',
    termsAndConditions:
      'Yes, I agree to the terms and conditions. You can find our privacy policy here',
    standardPaymentInfoTip:
      'Our standard shipping is carried out by established shipping service providers such as <b>UPS or DHL</b>. Depending on which carrier offers the best service in your region, we select the appropriate partner. For deliveries to Austria, delivery is made by Austrian Post.',
    paymentModes: {
      ct_paypal: 'PayPal',
      ct_creditcard_hop: 'Credit card',
      advancePayment: 'Advance payment',
      invoice: 'Invoice',
    },
    paymentModesDescription: {
      ct_paypal:
        "Paying with PayPal is easy, fast, and secure! Note: Your details will be requested after you submit your order. You must re-enter your PayPal details for each purchase. When paying with PayPal, you will be redirected to the PayPal website. PayPal's terms and conditions apply.",
      ct_creditcard_hop:
        'After submitting your order, you will be redirected to the credit card payment page (HOP hosted order page).',
      advancePayment: 'Payment can be made in advance.',
      invoice:
        'Payment after receipt of goods. You can conveniently pay the invoice amount by bank transfer within 14 days. We will send you the invoice preferably by email (PDF attachment).',
    },
    giftcardRedemptionDisabledTitle: 'Gift cards cannot be redeemed with prepayment',
    giftcardRedemptionDisabledDescription:
      'Please select a different payment method if you wish to redeem a gift card.',
    giftcardRedemptionDisabledButton: 'Proceed without gift card',
    giftcardRedemptionDisabledButtonSubmit: 'Change payment method',
  },
  habaPlaceOrder: {
    agb: 'Yes, I agree to the <a href="{{agbUrl}}" target="_blank" rel="noopener noreferrer">terms and conditions</a>.',
    dataProtection:
      'You can find our privacy policy <a href="{{privacyUrl}}" target="_blank" rel="noopener noreferrer">here</a>.',
    placeOrder: 'Place order with payment obligation',
    placeOrderShort: 'Place order now',
    agbError:
      'Please confirm that you have read and accepted our terms and conditions and privacy policy.',
    phoneModal: {
      title: 'Edit phone number',
      text: 'Your phone number is required so the freight carrier can contact you',
      inputPlaceholder: 'Phone number',
      submitButton: 'Save and continue',
    },
    phoneErrorMessage:
      'Your phone number <b>is required</b> so the <b>freight carrier can contact you</b>.',
    phoneSuccessMessage:
      'The phone number format appears to be correct. Please save your updates first and then <b>Place order with payment obligation</b>.',
    negativeTotalError:
      'An error has occurred. Gift card redemption and promotional discount result in a negative amount. Remove the gift card or promotional discount to complete the order.',
  },
  habaGuestLogin: {
    heading: 'Order as guest',
    emailAddress: {
      label: 'Email address',
      error: 'Please enter a valid email address.',
    },
    emailConfirmationAddress: {
      label: 'Confirm email address',
      error: 'The email address and email confirmation do not match.',
    },
    button: 'Continue to guest order',
  },
  habaCheckoutProgress: {
    login: 'Sign in',
    methodOfPayment: 'Payment',
    shippingAddress: 'Address',
    deliveryMode: 'Delivery',
    paymentDetails: 'Payment',
    reviewOrder: 'Confirm',
  },
  habaCheckoutInforbarText: {
    freeReturn: '14-day free return',
    noMinimumOrderValue: 'No minimum order value',
    carefullyTestedProducts: 'Carefully tested products',
    sparePartService: 'Spare part service',
  },
  habaCheckoutReview: {
    review: 'Your overview',
    cardTitle: {
      shippingAddress: 'Delivery address',
      billingAddress: 'Billing address',
      paymentMethod: 'Payment method',
      deliveryMethod: 'Shipping method',
      email: 'Email address',
      telephone: 'Phone number',
    },
    errors: {
      syncAtpCheckProductNotAvailable:
        'Stock no longer available. One or more products have been removed from your cart.',
      syncAtpCheckProductQuantityChanged:
        'Stock no longer available. Quantities have been reduced for one or more products.',
      generic: 'Order cannot be completed. Please try again later or contact our support team',
      syncAtpCheckProductNotAvailableQuantityChanged:
        'Stock no longer available. One or more products have been removed from your cart & quantities have been reduced for one or more products.',
      cartItemsPriceChanged: 'Product prices have been updated. Please review your order again',
      cartChanged: 'Your cart has been updated.',
      giftCardsRemoved: 'One or more gift cards have been removed. Please add them again.',
      invalidPaymentDetails: 'Please update your payment method',
      companyAddressesChanged: 'Your company data has changed. Please select your addresses again.',
      genericpayment:
        'A problem occurred while contacting the payment provider. Wait a few minutes and try again or choose a different payment method. If the problem persists, contact our customer service center.',
      paymentcanceled:
        'The payment process was cancelled. Please select a payment method to continue.',
      orderFromCartAlreadyExists:
        'An order has already been received for your cart. Please check your emails or contact our customer service.',
      purchaseGiftcardsAndRedemption:
        'Gift card redemption has been removed. When purchasing gift vouchers, no gift card can be used as a payment method',
    },
  },
  habaDeliveryModes: {
    title: 'Shipping',
    'standardversand-haba-de': 'Standard shipping',
  },
  habaCheckoutFooter: {
    customerService: {
      title: 'Customer service',
      description:
        'Monday to Friday from 8 AM to 4 PM at the customer service center in Bad Rodach!',
    },
    paymentMethods: {
      title: 'Payment methods & secure shopping',
      note: 'Prices in euros incl. statutory VAT plus service and shipping costs',
    },
  },
};
